module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/favicon-32x32-e17c984282c540b417482b4574d180af.png";